import { render, staticRenderFns } from "./InputLoader.vue?vue&type=template&id=507f80e9&"
import script from "./InputLoader.vue?vue&type=script&lang=ts&"
export * from "./InputLoader.vue?vue&type=script&lang=ts&"
import style0 from "./InputLoader.vue?vue&type=style&index=0&id=507f80e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports